import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AppBar, Toolbar, Typography, IconButton, Menu, MenuItem, Box } from '@mui/material';
import { AccountCircle } from '@mui/icons-material';
import logo from '../logo.png';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);

  // Scroll to top when location changes (page navigation)
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <AppBar position="static" sx={{ backgroundColor: 'rgb(14, 65, 133)', color: 'white' }}>
      <Toolbar>
        <div className="w-12 h-12 mr-4">
          <img
            src={logo}
            alt="Education logo"
            className="w-full h-full object-contain"
          />
        </div>
        
        <div className="flex flex-col">
          <Typography variant="h5" component="div" sx={{ flexGrow: 1, fontWeight: 500, color: 'white' }}>
            Ministry of Education
          </Typography>
          <Typography variant="body2" sx={{ fontSize: '0.875rem', fontWeight: 'normal', color: 'rgba(255, 255, 255, 0.8)' }}>
            National Examination Result Page
          </Typography>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default Header; 